import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { IManageUserMenuItemProperties } from '@bvi/admin-panel/feature/clients/ui/manage-user-menu/types';
import { UserStatus } from '@bvi/api-interfaces/entity/user';
import { ConfirmActionMenuItem } from '@bvi/common-components';

export const RestoreUserMenuItem: FC<IManageUserMenuItemProperties> = ({
  userStatus,
  onClick,
}) => {
  const { t } = useTranslation();

  return userStatus === UserStatus.DELETED ? (
    <ConfirmActionMenuItem
      question={t('users.actions.restore.question')}
      confirm={t('dialog.confirm')}
      cancel={t('dialog.cancel')}
      onClick={onClick}
    >
      {t('users.actions.restore.caption')}
    </ConfirmActionMenuItem>
  ) : null;
};
